@import 'apps/webcomponents/src/assets/common.scss';

.dashboard-settings-panel {
  padding-top: calc(var(--spacer) + 5px);
  height: 100%;

  .header {
    padding: 0 calc(var(--spacer) * 2);
  }

  .content {
    flex: 1;
    overflow: auto;
  }

  .footer {
    height: 56px;
  }

  gz-button[id*='resetWidgetsButton'] {
    &::part(button) {
      padding: 0;
    }
  }

  gz-list-item {
    padding: 0;
    height: auto;
    min-height: 32px;
    display: flex;
    align-items: center;
  }

  gz-text[class*='widget-title'] {
    height: auto;
    display: inline-block;
    word-break: normal;
  }
}
